export default function Navbar() {

  const reloadTo = (path) => {
    // Always force hard reload
    window.location.href = path;
  };

  return (
    <div style={styles.nav}>
      <h2 style={{ color: "#1976d2" }}>Face Recognition</h2>

      <div style={styles.links}>
        <button
          style={styles.btn}
          onClick={() => reloadTo("/")}
        >
          Scan
        </button>

        <button
          style={styles.btn}
          onClick={() => reloadTo("/register")}
        >
          Register
        </button>
      </div>
    </div>
  );
}

const styles = {
  nav: {
    height: 60,
    position: "sticky",
    top: 0,               
    zIndex: 1000,         
    background: "#fff",
    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
    padding: "0 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  links: {
    display: "flex",
    gap: 10
  },
  btn: {
    padding: "8px 16px",
    borderRadius: 6,
    border: "none",
    background: "#1976d2",
    color: "#fff",
    fontWeight: "bold",
    cursor: "pointer"
  }
};
